<template>
  <div class="middle-box text-center loginscreen animated fadeInDown">
    <h1 class="logo-name">FR</h1>

    <h3>FROTIX TESTAR</h3>

    <form class="m-t" role="form" novalidate @submit.prevent>
      <b-alert
        show
        fade
        variant="secondary"
        class="text-left"
      >
        <p><small>* Mínimo 6 dígitos;</small></p>
        <p><small>* Pelo menos 1 letra maiúscula, 1 minúscula e 1 número;</small></p>
      </b-alert>

      <b-alert
        :show="alert.show"
        @dismissed='alert.show = false'
        dismissible
        fade
        :variant="alert.type"
        class="text-left"
      >
        <p v-for="message in alert.message" :key="message.message"><small>{{ message }}</small></p>
      </b-alert>

      <div class="input-group mb-3">
        <input
          id="password"
          name="password"
          :type="newPasswordType"
          class="form-control"
          :placeholder="$t('new_password')"
          v-model="newPassword"
          v-validate="'required'"
        >

        <div class="input-group-append">
          <button
            type="button"
            class="btn btn-secondary"
            @click="newPasswordType = newPasswordType === 'text' ? 'password' : 'text'"
          >
            <span :class="[newPasswordType === 'text' ? 'fas fa-eye-slash' : 'fas fa-eye']" />
          </button>
        </div>
      </div>

      <div class="input-group mb-3">
        <input
          id="confirm_password"
          name="confirm_password"
          :type="confirmNewPasswordType"
          class="form-control"
          :placeholder="$t('confirm_new_password')"
          v-model="confirmNewPassword"
          v-validate="'required'"
        >

        <div class="input-group-append">
          <button
            type="button"
            class="btn btn-secondary"
            @click="confirmNewPasswordType = confirmNewPasswordType === 'text' ? 'password' : 'text'"
          >
            <span :class="[confirmNewPasswordType === 'text' ? 'fas fa-eye-slash' : 'fas fa-eye']" />
          </button>
        </div>
      </div>

      <LoaderButton
        @click="onClick"
        :loading="isLoading"
        full
        type='submit'
      >
        {{ $t('alter_password') }}
      </LoaderButton>

      <button
        type="button"
        class="btn btn-link btn-forget"
        @click="$router.push({ name: 'login' })"
      >
        {{ $t('back') }}
      </button>
    </form>

    <p class="m-t">
      <small>Locadados Data Solutions &copy; 2008-{{ new Date().getFullYear() }}</small>
    </p>

    <p><small>v{{ version }}</small></p>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import { addCls } from '@/lib/ui/domClass'
import { version } from '../../../package.json'

export default {
  name: 'Login',
  components: {
    LoaderButton
  },
  data () {
    return {
      newPassword: '',
      confirmNewPassword: '',
      version,
      newPasswordType: 'password',
      confirmNewPasswordType: 'password',
      loading: false,
      alert: {
        show: false,
        type: '',
        message: []
      }
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.session.isLoading
    })
  },

  methods: {
    ...mapActions('session', ['updatePassword']),

    async onClick (evt, doneFn) {
      let hasError = false

      if (this.newPassword !== this.confirmNewPassword) {
        hasError = true
      }

      if (this.newPassword.length < 6) {
        hasError = true
      }

      if (!/[a-z]/.test(this.newPassword)) {
        hasError = true
      }

      if (!/[A-Z]/.test(this.newPassword)) {
        hasError = true
      }

      if (!/[0-9]/.test(this.newPassword)) {
        hasError = true
      }

      if (hasError) {
        return this.alert = {
          show: true,
          type: 'danger',
          message: [
            '* Senha e confirmação devem ser iguais;',
            '* Senha deve conter no mínimo 6 dígitos;',
            '* Senha deve conter pelo menos 1 letra maiúscula, 1 minúscula e 1 número;'
          ]
        }
      }

      const { email, key } = this.$route.params

      const { result, message } = await this.updatePassword({ email, key, password: this.newPassword })

      if (!result) {
        return this.showAlert('danger', this.$t(message))
      }

      return this.$router.replace({ path: '/' })
    },

    showAlert(type, message) {
      this.alert = {
        show: true,
        type,
        message: []
      },

      this.alert.message.push(message)
    }
  },

  mounted () {
    const global = this

    $('#modalForgetPassword').on('hide.bs.modal', function () {
      global.alert.show = false
      global.emailRecover = ''
    })
  },

  created () {
    addCls('body', 'gray-bg')
  }
}
</script>

<style scoped>
  .btn-forget {
    font-size: 14px !important;
  }
</style>
